var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedin-square") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3---Account-Settings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "account-settings-oauth",
    transform: "translate(-420.000000, -880.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(406.000000, 676.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28-Copy-2",
    transform: "translate(0.000000, 190.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin-square",
    transform: "translate(14.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5575867,0 L1.44241332,0 C0.645751953,0 0,0.645751953 0,1.44241332 L0,18.5575867 C0,19.354248 0.645751953,20 1.44241332,20 L18.5575867,20 C19.354248,20 20,19.354248 20,18.5575867 L20,1.44241332 C20,0.645751953 19.354248,0 18.5575867,0 Z",
    id: "Shape",
    fill: "#2E76B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09411621,7.79006957 L7.09411621,15.1171875 L4.6586609,15.1171875 L4.6586609,7.79006957 L7.09411621,7.79006957 Z M13.072052,7.61810305 C14.6743774,7.61810305 15.8758545,8.66531371 15.8758545,10.9158325 L15.8758545,15.1171875 L13.4407043,15.1171875 L13.4407043,11.1973572 C13.4407043,10.2122498 13.0880738,9.54040527 12.2068787,9.54040527 C11.5341187,9.54040527 11.1334229,9.99359133 10.9573364,10.4310608 C10.8929443,10.587616 10.8772278,10.806427 10.8772278,11.0253906 L10.8772278,15.1171875 L8.44192504,15.1171875 L8.4424476,15.0050543 C8.44645392,14.1309145 8.47136279,8.42460047 8.44192504,7.79006957 L10.8772278,7.79006957 L10.8772278,8.82751465 C11.2008667,8.32824707 11.7799377,7.61810305 13.072052,7.61810305 Z M5.89263914,4.2578125 C6.72576906,4.2578125 7.23846438,4.80484008 7.25433352,5.52383422 C7.25433352,6.22695922 6.72576906,6.78955078 5.87646484,6.78955078 L5.8605957,6.78955078 C5.04333496,6.78955078 4.51477051,6.22695922 4.51477051,5.52383422 C4.51477051,4.80484008 5.0595093,4.2578125 5.89263914,4.2578125 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSquare);
export default __webpack_public_path__ + "static/media/linkedin-square.d6ba8b98.svg";
export { ForwardRef as ReactComponent };